<template>
  <div class="pay-container">跳转中....</div>
</template>

<script>
import { getRequestParameters } from "@/utils";
export default {
  data() {
    return {};
  },
  mounted() {
    const obj = getRequestParameters(window.location.href);
    if (!obj.path) {
      return;
    }
    window.location.href = decodeURIComponent(obj.path);
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.pay-container {
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #666;
}
</style>
